module.exports = __webpack_public_path__ + "img/keycloakbg.11b6c87f.png";